import { BasketColumnKeys } from 'graphql-api/baskets-api-interfaces';

const discountLocale = $localize`:CBasket|Basket column title Discount@@basketColumnTitleDiscount:Discount`;
const valueLocale = $localize`:CBasket|Basket column title Value@@basketColumnTitleValue:Value`;

export const basketHeaderColumnsLocale: Record<BasketColumnKeys, string> = {
  [BasketColumnKeys.DeliveryDate]: $localize`:CBasket|Basket column title Delivery Date@@basketColumnTitleDeliveryDate:Delivery Date`,
  [BasketColumnKeys.Markup]: $localize`:CBasket|Basket column title Markup@@basketColumnTitleMarkup:Markup`,
  [BasketColumnKeys.Wsp]: $localize`:CBasket|Basket column title Wsp@@basketColumnTitleWsp:WSP`,
  [BasketColumnKeys.Gross]: $localize`:CBasket|Basket column title Gross@@basketColumnTitleGross:Gross`,
  [BasketColumnKeys.Rrp]: $localize`:CBasket|Basket column title Rrp@@basketColumnTitleRrp:RRP`,
  [BasketColumnKeys.Quantity]: $localize`:CBasket|Basket column title Quantity@@basketColumnTitleQuantity:Quantity`,
  [BasketColumnKeys.Value]: valueLocale,
  [BasketColumnKeys.ValueRrp]: valueLocale,
  [BasketColumnKeys.ValueNet]: valueLocale,
  [BasketColumnKeys.Net]: $localize`:CBasket|Basket column title Net@@basketColumnTitleNet:Net`,
  [BasketColumnKeys.Total]: $localize`:CBasket|Basket column title Total@@basketColumnTitleTotal:Total`,
  [BasketColumnKeys.Discount]: discountLocale,
  [BasketColumnKeys.DiscountPercentage]: discountLocale,
  [BasketColumnKeys.DiscountRrp]: discountLocale,
  [BasketColumnKeys.DisplayDateFrom]: $localize`:CBasket|Basket column title Display Date From@@basketColumnTitleDisplayDateFrom:Season`,
  [BasketColumnKeys.CreatedDate]: $localize`:CBasket|Basket column title Created Date@@basketColumnTitleCreatedDate:Created Date`,
  [BasketColumnKeys.OrderType]: $localize`:CBasket|Basket column Order Type@@basketColumnOrderType:Order Type`,
  [BasketColumnKeys.ManualDiscount]: $localize`:CBasket|Basket column Manual Discount@@basketColumnManualDiscount:Discount`,
  [BasketColumnKeys.SimulatedTotal]: $localize`:CBasket|Basket column Simulated Total@@basketColumnSimulatedTotal:Total`,
  [BasketColumnKeys.ProductId]: $localize`:CBasket|Basket column product id@@basketColumnProductId:Product Id`,
  [BasketColumnKeys.Gender]: $localize`:CBasket|Basket column gender@@basketColumnGender:Gender`,
};
